import { render, staticRenderFns } from "./AError.vue?vue&type=template&id=4c66ecf8"
import script from "./AError.vue?vue&type=script&lang=js"
export * from "./AError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports